// i18nOwl-ignore [app-cohort.perkIntegrations.promo-code.title, app-cohort.perkIntegrations.promo-code.description, app-cohort.perkIntegrations.promo-code.usageViewComponent.userUsedCode]
import type {PerkIntegration} from '@cohort/merchants/apps';
import CohortPromoCodePerkIntegrationConfigComponent from '@cohort/merchants/apps/cohort/perkIntegrations/promoCode/ConfigComponent';
import {CohortPromoCodePerkIntegrationsUsagePreviewComponent} from '@cohort/merchants/apps/cohort/perkIntegrations/promoCode/UsagePreviewComponent';
import CohortPromoCodePerkIntegrationsUsageViewComponent from '@cohort/merchants/apps/cohort/perkIntegrations/promoCode/UsageViewComponent';
import type {CohortPromoCodePerkIntegrationStruct} from '@cohort/shared/apps/cohort/perks/promoCode';
import {CohortPromoCodePerkIntegrationSpec} from '@cohort/shared/apps/cohort/perks/promoCode';

export const CohortPromoCodePerkIntegration: PerkIntegration<CohortPromoCodePerkIntegrationStruct> =
  {
    spec: CohortPromoCodePerkIntegrationSpec,
    configComponent: CohortPromoCodePerkIntegrationConfigComponent,
    usageViewComponent: CohortPromoCodePerkIntegrationsUsageViewComponent,
    usagePreviewComponent: CohortPromoCodePerkIntegrationsUsagePreviewComponent,
    iconColor: 'text-blue-500',
    backgroundColor: 'bg-blue-100',
  };
